import { render, staticRenderFns } from "./CompaniesManagement.vue?vue&type=template&id=1cb2b854"
import script from "./CompaniesManagement.vue?vue&type=script&lang=js"
export * from "./CompaniesManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports